import Splide, { Options } from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', () => {
  // スライダーのセレクター配列
  const sliderSelectors = [
    '[data-near-spot-slider]',
    '[data-nearby-event-slider]',
  ];

  // 共通の設定 single-spot.phpの近くのスポット
  const commonOptions: Options = {
    perPage: 1,
    padding: '10%',
    type: 'slide',
    omitEnd: true,
    gap: 16,
    classes: {
      pagination: 'splide__pagination default-pagination',
      page: 'splide__pagination__page default-pagination__page',
    },
    mediaQuery: 'min' as const,
    breakpoints: {
      768: {
        perPage: 3,
        padding: 0,
      },
    },
  };

  // スライダーを初期化する関数
  const initializeSlider = (selector: string, options: Options) => {
    document.querySelectorAll<HTMLElement>(selector).forEach((el) => {
      const splide = new Splide(el, options);

      const updateArrowsVisibility = () => {
        const arrows = splide.root.querySelector(
          '.splide__arrows'
        ) as HTMLElement | null;

        if (arrows) {
          const end = splide.Components.Controller.getEnd();
          arrows.style.display = end === 0 ? 'none' : '';
        }
      };

      splide.on('mounted', updateArrowsVisibility);
      splide.on('resized', updateArrowsVisibility);

      splide.mount();
    });
  };

  // 各スライダーを初期化
  sliderSelectors.forEach((selector) =>
    initializeSlider(selector, commonOptions)
  );

  // Feature page: 関連スポット（PC時はグリッド表示）
  const featureSpotOptions: Options = {
    perPage: 1,
    padding: '10%',
    type: 'slide',
    omitEnd: true,
    gap: 16,
    classes: {
      pagination: 'splide__pagination default-pagination',
      page: 'splide__pagination__page default-pagination__page',
    },
    mediaQuery: 'min' as const,
    breakpoints: {
      768: {
        destroy: true,
      },
    },
  };

  initializeSlider('[data-feature-spot-slider]', featureSpotOptions);

  // モデルコースのmv
  const modelCourseSliderSelector = document.querySelector<HTMLElement>(
    '[data-model-course-mv]'
  );
  const modelCourseSliderOptions: Options = {
    type: 'fade', // フェード効果を有効化
    autoplay: true, // 自動再生を有効化
    interval: 5000, // 3秒間隔で切り替え
    speed: 5000, // フェードの速度（1秒）
    rewind: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    arrows: false,
  };
  if (modelCourseSliderSelector) {
    new Splide(modelCourseSliderSelector, modelCourseSliderOptions).mount();
  }

  // モデルコースのINDEX
  const modelCourseIndexOptions: Options = {
    autoWidth: true,
    padding: '10%',
    type: 'slide',
    focus: 0,
    omitEnd: true,
    gap: 16,
    classes: {
      pagination: 'splide__pagination default-pagination',
      page: 'splide__pagination__page default-pagination__page',
    },
  };
  document
    .querySelectorAll<HTMLElement>('[data-model-course-index]')
    .forEach((el) => {
      const splide = new Splide(el, modelCourseIndexOptions);
      const updateArrowsVisibility = () => {
        const arrows = splide.root.querySelector(
          '.splide__arrows'
        ) as HTMLElement | null;
        if (arrows) {
          const end = splide.Components.Controller.getEnd();
          arrows.style.display = end === 0 ? 'none' : '';
        }
      };
      splide.on('mounted', updateArrowsVisibility);
      splide.on('resized', updateArrowsVisibility);
      splide.mount();
    });

  const newsMvSelector = document.querySelector<HTMLElement>(
    '[data-single-news-slider]'
  );
  if (newsMvSelector) {
    const splide = new Splide(newsMvSelector, {
      mediaQuery: 'min' as const,
      perPage: 1,
      padding: '10%',
      type: 'slide',
      omitEnd: true,
      gap: 16,
      classes: {
        pagination: 'splide__pagination default-pagination',
        page: 'splide__pagination__page default-pagination__page',
      },
      breakpoints: {
        768: {
          padding: '20%',
        },
      },
    });

    const updateBrightness = () => {
      const slides = newsMvSelector.querySelectorAll('.splide__slide');
      slides.forEach((slide, index) => {
        const img = slide.querySelector('img');
        if (!img) return;
        if (index === splide.index) {
          img.classList.remove('brightness-75');
        } else {
          img.classList.add('brightness-75');
        }
      });
    };

    const updateArrowsVisibility = () => {
      const arrows = splide.root.querySelector(
        '.splide__arrows'
      ) as HTMLElement | null;
      if (arrows) {
        const end = splide.Components.Controller.getEnd();
        arrows.style.display = end === 0 ? 'none' : '';
      }
    };

    splide.on('mounted', updateBrightness);
    splide.on('mounted', updateArrowsVisibility);
    splide.on('moved', updateBrightness);
    splide.on('resized', updateArrowsVisibility);

    splide.mount();
  }
});
